import getAppTheme from "./utils/getAppTheme";
import getAppName from "./utils/getAppName";
import getPanelBG from "./utils/getPanelBG";
import getColorFromDeltaOffset from "./utils/getColorFromDeltaOffset";

import ILSTdarkest from "./stylesheets/ILST/darkest.json";
import ILSTdark from "./stylesheets/ILST/dark.json";
import ILSTlight from "./stylesheets/ILST/light.json";
import ILSTlightest from "./stylesheets/ILST/lightest.json";
import PHXSdarkest from "./stylesheets/PHXS/darkest.json";
import PHXSdark from "./stylesheets/PHXS/dark.json";
import PHXSlight from "./stylesheets/PHXS/light.json";
import PHXSlightest from "./stylesheets/PHXS/lightest.json";
import IDSNdarkest from "./stylesheets/IDSN/darkest.json";
import IDSNdark from "./stylesheets/IDSN/dark.json";
import IDSNlight from "./stylesheets/IDSN/light.json";
import IDSNlightest from "./stylesheets/IDSN/lightest.json";
import AEFTgradient from "./stylesheets/AEFT/gradient.json";
import PPROgradient from "./stylesheets/PPRO/gradient.json";
import AUDTgradient from "./stylesheets/AUDT/gradient.json";

let themes = {};
let starlette;
export default (starlette = {
  currentTheme: [],
  loadThemes() {
    themes["ILSTdarkest"] = ILSTdarkest;
    themes["ILSTdark"] = ILSTdark;
    themes["ILSTlight"] = ILSTlight;
    themes["ILSTlightest"] = ILSTlightest;
    themes["AEFTgradient"] = AEFTgradient;
    themes["PHXSdarkest"] = PHXSdarkest;
    themes["PHXSdark"] = PHXSdark;
    themes["PHXSlight"] = PHXSlight;
    themes["PHXSlightest"] = PHXSlightest;
    themes["PPROgradient"] = PPROgradient;
    themes["IDSNdarkest"] = IDSNdarkest;
    themes["IDSNdark"] = IDSNdark;
    themes["IDSNlight"] = IDSNlight;
    themes["IDSNlightest"] = IDSNlightest;
    themes["AUDTgradient"] = AUDTgradient;
  },
  getColorAs(name, appName, theme = null, gradientvalue = null) {
    if (!themes["ILSTdarkest"]) this.loadThemes();
    let currentTheme, panelBG;
    if (/ILST|IDSN|PHXS/i.test(appName)) {
      currentTheme = themes[appName + theme];
      if (/darkest/i.test(theme)) panelBG = [50, 50, 50];
      else if (/dark$/i.test(theme)) panelBG = [83, 83, 83];
      else if (/light$/i.test(theme)) panelBG = [184, 184, 184];
      else if (/lightest/i.test(theme)) panelBG = [240, 240, 240];
    } else {
      currentTheme = themes[appName + "gradient"];
      if (gradientvalue) {
        gradientvalue = gradientvalue < 0 ? 0 : gradientvalue;
        gradientvalue = gradientvalue > 100 ? 100 : gradientvalue;
      }
      panelBG =
        !gradientvalue || gradientvalue == 0
          ? [35, 35, 35]
          : [
              Math.floor((gradientvalue / 100) * 48 + 35),
              Math.floor((gradientvalue / 100) * 48 + 35),
              Math.floor((gradientvalue / 100) * 48 + 35)
            ];
    }
    return getValue(
      currentTheme.find(item => {
        return item.title == name;
      }),
      panelBG
    );
  },
  parseTheme(str) {
    str = str.data || str;
    let panelBG, gradientvalue, theme;
    theme = str.substring(4);
    if (/ILST|IDSN|PHXS/i.test(str)) {
      if (/darkest/i.test(theme)) panelBG = [50, 50, 50];
      else if (/dark/i.test(theme)) panelBG = [83, 83, 83];
      else if (/light/i.test(theme)) panelBG = [184, 184, 184];
      else if (/lightest/i.test(theme)) panelBG = [240, 240, 240];
    } else {
      gradientvalue = +str.split(";")[1];
      panelBG =
        !gradientvalue || gradientvalue == 0
          ? [35, 35, 35]
          : [
              Math.floor((gradientvalue / 100) * 48 + 35),
              Math.floor((gradientvalue / 100) * 48 + 35),
              Math.floor((gradientvalue / 100) * 48 + 35)
            ];
    }
    let currentTheme = /ILST|IDSN|PHXS/i.test(str)
      ? themes[theme]
      : themes[str.split(";")[0] + "gradient"];
    currentTheme.forEach(cssVar => {
      setCSS(cssVar.title, getValue(cssVar, panelBG));
    });
  },
  initAs(appName, theme, gradientvalue = null) {
    this.loadThemes();
    window.addEventListener("message", this.parseTheme);
    let panelBG;
    if (/ILST|IDSN|PHXS/i.test(appName)) {
      if (/darkest/i.test(theme)) panelBG = [50, 50, 50];
      else if (/dark/i.test(theme)) panelBG = [83, 83, 83];
      else if (/light/i.test(theme)) panelBG = [184, 184, 184];
      else if (/lightest/i.test(theme)) panelBG = [240, 240, 240];
    } else {
      panelBG =
        !gradientvalue || gradientvalue == 0
          ? [35, 35, 35]
          : [
              Math.floor((gradientvalue / 100) * 48 + 35),
              Math.floor((gradientvalue / 100) * 48 + 35),
              Math.floor((gradientvalue / 100) * 48 + 35)
            ];
    }
    let currentTheme = themes[appName + theme];
    currentTheme.forEach(cssVar => {
      setCSS(cssVar.title, getValue(cssVar, panelBG));
    });
  },
  init() {
    this.loadThemes();
    window.__adobe_cep__.addEventListener(
      "com.adobe.csxs.events.ThemeColorChanged",
      this.appThemeChanged
    );
    this.appThemeChanged();
  },
  appThemeChanged() {
    this.currentTheme = [];
    let panelBG = getPanelBG();
    let currentTheme = themes[getAppName() + getAppTheme()];
    currentTheme.forEach(cssVar => {
      setCSS(cssVar.title, getValue(cssVar, panelBG));
    });
  },
  buildTableForApp(appName) {
    let mirror = [];
    if (/ILST|PHXS|IDSN/.test(appName)) {
      let baseTheme = themes[appName + "darkest"].reverse();
      baseTheme.forEach((item, i) => {
        let darkest = getValue(item, [50, 50, 50]);
        let dark = getValue(
          themes[appName + "dark"].find(entry => {
            return entry.title == item.title;
          }),
          [83, 83, 83]
        );
        let light = getValue(
          themes[appName + "light"].find(entry => {
            return entry.title == item.title;
          }),
          [184, 184, 184]
        );
        let lightest = getValue(
          themes[appName + "lightest"].find(entry => {
            return entry.title == item.title;
          }),
          [240, 240, 240]
        );
        let line;
        if (item.hex || item.delta) {
          line = `| --${
            item.title
          } | ![${darkest}](https://placehold.it/15/${darkest.replace(
            "#",
            ""
          )}/ffffff?text=+) \`${darkest}\`  | ![${dark}](https://placehold.it/15/${dark.replace(
            "#",
            ""
          )}/ffffff?text=+) \`${dark}\`  | ![${light}](https://placehold.it/15/${light.replace(
            "#",
            ""
          )}/ffffff?text=+) \`${light}\`  | ![${lightest}](https://placehold.it/15/${lightest.replace(
            "#",
            ""
          )}/ffffff?text=+) \`${lightest}\` |`;
          mirror.push(line);
        }
      });
    } else {
      let baseTheme = themes[appName + "gradient"].reverse();
      baseTheme.forEach((item, i) => {
        let darkest = getValue(item, [
          Math.floor(39.25),
          Math.floor(39.25),
          Math.floor(39.25)
        ]);

        let mid = getValue(item, [
          Math.floor(64),
          Math.floor(64),
          Math.floor(64)
        ]);
        let lightest = getValue(item, [
          Math.floor(90.25),
          Math.floor(90.25),
          Math.floor(90.25)
        ]);
        let line;
        if (item.hex || item.delta) {
          line = `| --${
            item.title
          } | ![${darkest}](https://placehold.it/15/${darkest.replace(
            "#",
            ""
          )}/ffffff?text=+) \`${darkest}\`  | ![${mid}](https://placehold.it/15/${mid.replace(
            "#",
            ""
          )}/ffffff?text=+) \`${mid}\`  | ![${lightest}](https://placehold.it/15/${lightest.replace(
            "#",
            ""
          )}/ffffff?text=+) \`${lightest}\` |`;
          mirror.push(line);
        }
      });
    }
    return mirror;
  }
});

function getValue(item, color) {
  if (item.delta || item.delta <= 0) {
    if (+item.delta + +color[0] >= 255) return "#ffffff";
    else return getColorFromDeltaOffset(color, item.delta);
  } else if (item.hex) {
    return item.hex;
  } else if (item.value) {
    return item.value;
  }
}

function getCSS(prop) {
  return window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(`${/^\-\-/.test(prop) ? prop : "--" + prop}`);
}
function setCSS(prop, data) {
  document.documentElement.style.setProperty(
    `${/^\-\-/.test(prop) ? prop : "--" + prop}`,
    data
  );
}
